import React, { useState, useEffect } from 'react';
import OccupancyInput from './OccupancyInput.js'
import InputNumber from './InputNumber.js';

export default function ChangeOccupancy(props) {

    const [adults, setAdults] = useState(props.adults);
    const [dummy, setDummy] = useState();
    const [children, setChildren] = useState(props.children);

    
    

    function cancel() {
        props.close();
    }

    function apply() {
        props.changeAdults(props.roomTypeName, adults);
        props.changeChildren(props.roomTypeName, children);
        props.apply(adults, children);
    }

    const changeAdults = value => {
        setAdults(value);
    }

    const changeChildren = value => {
        setChildren(value);
    }
    

    

    return (
        <div>

            <div class="card">
                <div class="card-body">
                    <h5 class="card-title">Select Room Occupants</h5>
                    <div class="row">
                        <div className="col-5">
                            <div className="align-middle" style={{ height: '38px', lineHeight: '38px', marginLeft: '12px' }}>Adults</div>

                        </div>
                        <div class="col-7">
                            <InputNumber min={1} max={props.roomType.maxCapacity - children} value={adults} onChange={(v) => changeAdults(v)} />
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-5">
                            <div className="align-middle" style={{ height: '38px', lineHeight: '38px', marginLeft: '12px' }}>Children</div>
                        </div>
                        <div class="col-7">
                            <InputNumber min={0} max={props.roomType.maxCapacity - adults} value={children} onChange={(v) => changeChildren(v)} />
                        </div>
                    </div>

                    <div className='row'>
                        <div className='col-12 text-right'>
                        <button
                            type="button"
                            className="btn btn-link "
                            onClick={() => cancel()}
                        >Cancel</button>

                        <button
                            type="button"
                            className="btn btn-link "
                            onClick={() => apply()}
                            >Apply</button>
                        </div>
                    </div>
                </div>
            </div>

        </div>

    );

}